import { render, staticRenderFns } from "./SFormCol.vue?vue&type=template&id=f8ae103c&scoped=true&"
import script from "./SFormCol.vue?vue&type=script&lang=js&"
export * from "./SFormCol.vue?vue&type=script&lang=js&"
import style0 from "./SFormCol.vue?vue&type=style&index=0&id=f8ae103c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ae103c",
  null
  
)

export default component.exports